module.exports = __webpack_public_path__ + "e16f512b163de48a3bfbadb9ff2156e7.jpg";